<template>
  <div class="page">
    <h2>Stap nu eenvoudig in met gratis zonnepanelen.</h2>
    <h3>Wat levert jouw dak op?</h3>
    <form class="page-form">
      <div class="form-row">
        <div
          class="form-col form-col-zip"
          :class="{invalid : !zipcode_validated}">
          <label>Postcode<span>*</span></label>
          <input
            v-on:focus="zipcode_validated = true"
            v-on:blur="validate_zipcode"
            v-model="postcode"
            type="text"
            placeholder="1234 AB" />
        </div>
        <div class="form-col form-col-small">
          <label>Huisnummer<span>*</span></label>
          <input v-model="huisnummer" type="number" min="1" placeholder="1"  />
        </div>
        <div class="form-col form-col-small">
          <label>Toevoeging</label>
          <input v-model="toevoeging" type="text" placeholder="a" />
        </div>
      </div>
      <div class="form-row">
        <div class="form-col">
          <br>
          <label>Ben je in bezit van een koophuis?</label>
          <toggle
            v-model="bezit_koophuis"
            label-checked="ja"
            label-unchecked="nee" />
        </div>
      </div>
      <div class="form-row nav-buttons bottom">
        <br>
        <button v-bind:class="{ enabled : isCompleted }" v-on:click="next()" type="button">Volgende</button>
      </div>
    </form>
  </div>
</template>

<script>
  import toggleComponent from './../components/toggleComponent.vue';
  import validations from './../plugins/validations.js';

  export default {
    name: 'dakcheckPage',
    components: {
      'toggle' : toggleComponent
    },
    mounted() {
      this.$store.dispatch('set_step_to', this.step)
    },
    data : function(){
      return{
        step : 1,
        zipcode_validated : true,
      }
    },
    computed: {
      isCompleted() {
        return this.$store.getters.is_completed_step(this.step)
      },
      postcode: {
        get () { return this.$store.state.userData.postcode },
        set (value) { this.$store.dispatch('update_userdata_for', { fieldname: 'postcode', value: value, step: 1 }) }
      },
      huisnummer: {
        get () { return this.$store.state.userData.huisnummer },
        set (value) { this.$store.dispatch('update_userdata_for', { fieldname: 'huisnummer', value: value, step: 1 }) }
      },
      toevoeging: {
        get () { return this.$store.state.userData.toevoeging },
        set (value) { this.$store.dispatch('update_userdata_for', { fieldname: 'toevoeging', value: value, step: 1 }) }
      },
      bezit_koophuis: {
        get () { return this.$store.state.userData.bezit_koophuis },
        set (value) { this.$store.dispatch('update_userdata_for', { fieldname: 'bezit_koophuis', value: value, step: 1 }) }
      }
    },
    methods : {
      validate_zipcode() {
        this.postcode = this.postcode.replace(/\s/g,'')
        this.zipcode_validated = validations.zipcode_nl(this.postcode)
      },
      next() {
        if( this.isCompleted == true ) {
          this.$router.replace('/analyse')
        }
      }
    },
  }
</script>

<style scoped lang="scss">
</style>
